import { AxiosInstance } from "axios"
import { SchedulerJob, JobStatus, JobCommand, EditSchedulerJobBody, SchedulerJobDetails } from "./schedulerTypes"
import { ServiceResponse } from "../../../../../core/api/apiTypes"

export enum SupportSchedulerQuery {
    SCHEDULER_STATUS = "scheduler-status",
    SCHEDULER_JOB_DETAILS = "scheduler-job-details",
}

export type SchedulerStatusResponse = Readonly<{
    scheduler: {
        status: JobStatus
        loadInSeconds: number
        jobs: Array<SchedulerJob>
    }
}>

export async function fetchSchedulerStatus(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SchedulerStatusResponse> {
    const { data } = await axios.get("/scheduler/status", {
        signal,
    })
    return data
}

export type SchedulerJobByIdResponse = Readonly<{
    schedulerJob: SchedulerJobDetails
}>

export async function fetchSchedulerJobDetails(
    { jobId }: { jobId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SchedulerJobByIdResponse> {
    const { data } = await axios.get(`/scheduler/jobs/${jobId}`, {
        signal,
    })
    return data
}

export async function callSchedulerJob(
    { jobId, command }: { jobId: number; command: JobCommand },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const response = await axios.post(
        `/scheduler/jobs/${jobId}/command`,
        {
            command,
        },
        { signal },
    )

    return response.data
}

export async function editSchedulerJob(
    { jobId, body }: { jobId: number; body: EditSchedulerJobBody },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const response = await axios.post(
        `/scheduler/jobs/${jobId}`,
        {
            ...body,
        },
        { signal },
    )

    return response.data
}
